import { render } from "./GeneralContent.vue?vue&type=template&id=00d0127a&ts=true"
import script from "./GeneralContent.vue?vue&type=script&lang=ts"
export * from "./GeneralContent.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__